<!--订单详情-->
<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="详情" size="90%" :before-close="handleClose" :visible.sync="drawer"
    modal-append-to-body="false" :modal="isShow" style="margin-top: 40px;position: absolute;left: 0px;z-index: 2033;width: 100%;"
      direction="rtl"  custom-class="demo-drawer" ref="drawer" class="details2">

      <div class="demo-drawer__content">

        <template>
          <div>
            <!-- 服务商 -->
            <div class="detail-wrap">
              <el-form ref="editForm" :model="formData">
                <div class="d-header">
                  <div class="" style="padding: 5px;border-bottom: 1px solid #ededed">
                    <i class="el-icon-info" style="color: #00c4b3;" />
                    <!-- {{ dataId ? '查看' : '新增' }}订单 -->
                    <!-- 订单号：<span style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.orderNumber }}</span> -->
                  </div>
                </div>
                <div class="d-cont edit-mce-box">
                  <!-- <div class="d-item">
                    <div class="title first" v-if="formData.timeSequences"><b><span>节点图</span></b></div>
                    <div><el-steps :active="timeSeq" align-center finish-status="success" v-if="formData.timeSequences">
                        <el-step :title="item.processName" :description="item.processDate" :key="item.index"
                          v-for="item in formData.timeSequences"></el-step>
                      </el-steps></div>
                  </div> -->
                  <div class="d-item">
                    <div class="title first"><b>客户信息</b></div>
                    <table class="table-detail">
                      <tbody>
                        <tr style="display: block;">
                          <th>订单号</th>
                          <td>{{ formData.saleOrderNo}}</td>
                          <th>客户姓名/号码</th>
                          <td>{{ formData.userName }} / {{ formData.userMobile }}</td>
                          <th>创建时间</th>
                          <td>{{ formData.createTime }}</td>
                          <th>详细地址</th>
                          <td style="width: 27vw!important;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                            {{ formData.userProvice }}{{ formData.userCity }}{{formData.userCounty}}{{ formData.userTown }}{{ formData.userAddress }}
                          </td>
                        </tr>
                        <tr style="display: block;">
                          <th>服务商名</th>
                          <td>{{ formData.siteName}}</td>
                          <th>工程师</th>
                          <td>{{ formData.engineerName }}</td>
                          <th>运营商名</th>
                          <td>{{ formData.proxyCompanyName }}</td>
                          <th>保司名称</th>
                          <td>{{ formData.insureCompanyName }}</td>
                        </tr>
                        <tr style="display: block;">
                          <th>故障原因</th>
<!--                          <td style="width: 61vw!important;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">-->
                          <td>
                            {{ formData.faultRemark }}
                          </td>
                          <th>维修说明</th>
                          <td>
                            {{ formData.fixRemark }}
                          </td>
                          <th>方案驳回原因</th>
                          <td>
                            {{ formData.claimMessage}}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="d-item" style="padding-top: 10px;">
                    <div class="title first"><b>机器信息</b></div>
                    <table class="table-detail">
                      <tbody>
                        <tr>
                          <th>sn编码</th>
                          <td>{{ formData.barcode }}</td>
                          <th>机器型号</th>
                          <td>{{ formData.itemModel }}</td>
                          <th>机器品类</th>
                          <td>{{ formData.categoryName }}</td>
                          <th>维修方案</th>
                          <td v-if="formData.isAmount==0">500元以下</td>
                          <td v-else-if="formData.isAmount==1">500元以上</td>
                          <td v-else></td>
                        </tr>
                        <tr>
                          <th>维修措施</th>
                          <td v-if="formData.methodType==1">检测调试</td>
                          <td v-else-if="formData.methodType==2">配件更换</td>
                          <td v-else></td>
                          <th>状态</th>
                          <td v-if="formData.insurePayStat==0">无审核</td>
                          <td v-else-if="formData.insurePayStat==1">审核中</td>
                          <td v-else-if="formData.insurePayStat==2">同意理赔</td>
                          <td v-else-if="formData.insurePayStat==3">不同意理赔</td>
                          <td v-else></td>
<!--                          <th>购买渠道</th>-->
<!--                          <td>{{ formData.buyShop }}</td>-->
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="d-item" style="padding-top: 10px;">
                    <div class="title first"><b>费用信息</b></div>
                    <table class="table-detail">
                      <tbody>
                        <tr>
                          <th>检测调试费</th>
                          <td>{{ formData.serviceFee }}</td>
                          <th>维修费</th>
                          <td>{{ formData.serviceFee }}</td>
                          <th>配件费</th>
                          <td>{{ formData.partsFee }}</td>
                          <th>远程费</th>
                          <td>{{ formData.longDistanceFee }}</td>
                          <th>费用总计</th>
                          <td>{{ formData.amount }}</td>
                        </tr>

                      </tbody>
                    </table>
                  </div>

                  <!-- <div class="d-item">
                    <div class="title first"><b>费用信息</b></div>
                    <div>
                      <vxe-table ref="filterTable" :data="formData.soOrderLineDTOList" class="table_item"
                        style="margin:0px auto; width: 95%;" :stripe="true"
                        :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                        :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                        show-overflow height="100" :column-config="{ resizable: true }">
                        <vxe-column type="selection" width="55"></vxe-column> -->

                        <!-- <vxe-column width="100" field="itemCode" title="上门费" /> -->
                        <!-- <vxe-column width="100" field="serviceFee" title="检测调试费" />
                        <vxe-column width="100" field="serviceFee" title="维修费" />
                        <vxe-column width="100" field="partsFee" title="配件费" />
                        <vxe-column width="100" field="longDistanceFee" title="远程费" />
                        <vxe-column width="100" field="amount" title="费用总计" /> -->
                        <!-- <vxe-column width="100" field="sitePrice" title="退换货拆机费" />
                        <vxe-column width="100" field="siteFee" title="装机费" />
                        <vxe-column width="100" field="itemCode" title="机器运输费" />
                        <vxe-column width="100" field="itemName" title="异地送修费" />
                        <vxe-column width="100" field="bigCategoryName" title="其他费用" />
                        <vxe-column width="100" field="smallCategoryName" title="通融赔付费" />
                        <vxe-column width="100" field="bigCategoryName" title="通融赔付人员" />
                        <vxe-column width="100" field="smallCategoryName" title="新机费用" /> -->

                      <!-- </vxe-table>
                    </div>
                  </div> -->

                  <div style="height: 70px;"></div>
                </div>
              </el-form>
            </div>
          </div>
        </template>
      </div>
    </el-drawer>
  </div>
</template>
<script>
// import orderPop from './orderDialog.vue'
import api from "@/api/projectApi";
export default {
  inject: ['reload'],
  name: 'orderDetailDialog',
  props: ['multi', 'dataId'],
  components: {

  },
  created() {
    this.dataId = this.dataId
    console.log(this.dataId, "传过来的值");
  },
  data() {
    return {
      isShow:false,
      show3: false,
      dataId: '',
      form2: {
        desc: '',
        name: "",
      },
      // showOrderPop: false,
      timeSeq: '',
      drawer: true,
      formData: {
        orderNumber: '',
        userName: '', // 用户姓名
        userMobile: '', // 来电号码
        userProvice: '', // 省
        userCity: '', // 市
        userCounty: '', // 县
        userTown: '', // 镇街
        userAddress: '', // 详细地址
        barcode: '', // 条码

        siteName: '',
        engineerName: '',
        proxyCompanyName: '',
        insureCompanyName: '',
        faultRemark: '',
        fixRemark: '',
        claimMessage: '',
        itemModel: '',
        categoryName: '',
        isAmount: '',

        methodType: '',
        insurePayStat: '',
        serviceFee: 0,
        partsFee: 0,
        longDistanceFee: 0,
        amount: 0,


      },
      srcList: [],

    }
  },
  mounted() {
    // this.initTableList();
    this.getData();
    //   console.log(this.tenant, "tenant的值");
    console.log(this.dataId, "_dataId的值");
  },
  methods: {
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        //   this.isEdit = true;
        this.$http({
          url: api.soOrderInsureApply.getId,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data
          console.log(this.formData, "this.formData的值市");
          var timeSeqs = this.formData.timeSequences;
          // var a = 0;
          // for (var i = 0; i < timeSeqs.length; i++) {
          //   if (timeSeqs[i].processDate != null) {
          //     a = i;
          //   }
          // }

        })
      } else {
        this.enabled = true;
      }
    },
    // 订单弹窗选中
    orderCommit(row) {
      console.log(row, '弹窗数据')
      this.formData.orderNo = row.orderNo
      this.formData.orderId = row.orderId
    },
    shut() {
      // this.showOrderPop=true
    },
    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('goBackIndex', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.details2 {

  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }

  //   3个标签
  .information {
    padding: 0px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
    font-size: 15px;
  }

  //   每个分支
  .d-item {
    border: 1px solid #ededed;
    padding-bottom: 5px;
    position: relative;

    .title b {
      display: inline-block;
      line-height: 20px;
      font-size: 13px;
      font-weight: 600;
      margin-right: 84px;
      vertical-align: middle;
      color: rgb(42, 100, 148);
      position: relative;
      z-index: 2;
      background: rgba(42, 100, 148, 0.16);
      margin-left: 0px;
      margin-bottom: 8px;
      padding-left: 12px;
      padding-right: 14px;
      border-radius: 0px 28px 28px 0px;
    }

    .table-detail tr {
      margin-bottom: 10px;
      display: block;

      th {
        font-weight: 400;
        text-align: right;
        width: 7vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 5px 0 4px;
        color: rgba(86, 86, 86, 0.96);
      }

      td {
        font-weight: 400;
        // text-align: right;
        width: 10vw !important;
        font-size: 12px;
        position: relative;
        padding: 0 0px 0 4px;
        color: rgba(0, 0, 0, );
      }
    }
  }

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 20px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        white-space: nowrap;
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 本单费用位置
  .expense {
    position: absolute;
    // right: 20%;
    left: 13vw;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }

  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }

  ::v-deep .el-step__title {
    font-size: 13px !important;
    line-height: 38px;
  }
}

.Instructions {
  text-decoration: underline;
  color: #00c4b3;
  margin-left: 5px;
}
::v-deep .el-collapse-item__wrap {
     border-bottom:none !important;
}
::v-deep .el-collapse-item__arrow{
  position: absolute;
    right: 0;
    top: 5px;
}
::v-deep .el-collapse {
  border: none!important;
    }
::v-deep .el-collapse-item__header {
    height: 1px ;
    border: none!important;
    }
</style>
